<template>
  <div>
    <h3>Umsatz</h3>
    <vue-c3 :handler="handler" id="turnover"></vue-c3>
  </div>
</template>

<script>

import { mapMutations, mapGetters, mapActions } from 'vuex';
//import ChartBasic from "@/components/ChartBasic.vue";
//<chart-basic></chart-basic>
//ChartBasic

import Vue from "vue";
import VueC3 from 'vue-c3';
import 'c3/c3.min.css';
import axios from "axios";
//import d3 from 'vue-c3';

//import axios from "axios";

/*
var germanFormatters = d3.locale({
  "decimal": ",",
  "thousands": ".",
  "grouping": [3],
  "currency": ["", " €"],
  "dateTime": "%a %b %e %X %Y",
  "date": "%d.%m.%Y",
  "time": "%H:%M:%S",
  "periods": ["AM", "PM"],
  "days": ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
  "shortDays": ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  "months": ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
  "shortMonths": ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"]
});

 */

/*
var customTimeFormat = germanFormatters.timeFormat.multi([
  [".%L", function(d) { return d.getMilliseconds(); }],
  [":%S", function(d) { return d.getSeconds(); }],
  ["%I:%M", function(d) { return d.getMinutes(); }],
  ["%Hh", function(d) { return d.getHours(); }],
  ["%a %d", function(d) { return d.getDay() && d.getDate() != 1; }],
  ["%b %d", function(d) { return d.getDate() != 1; }],
  ["%B", function(d) { return d.getMonth(); }],
  ["%Y", function() { return true; }]
]);

 */

export default {
  name: "chartTurnoverWeeks",
  components: {
    VueC3
  },
  data() {
    return {
      API_URL: process.env.VUE_APP_API,
      handler: new Vue(),
      val: 100,
      data: {
        columns: [],
        types: []
      },
      categories: '',
    }
  },
  mounted () {
    this.getChartData();
    //this.handler.$emit('init', this.options);
  },
  created() {


  },
  computed: {
    ...mapGetters([
      'getRecordingDates',
      'getUser',
      'getIsLoggedIn'
    ]),
    options() {
      return {
        bindto: '#turnover',
        size: {
          width: 1200,
          height: 600,
        },
        color: {
          pattern: ['#CE1D1C','#83D0F5','#CF5A1D','#82BDF5','#CF781D','#82A9F5','#CF971D','#8295F5','#CFB51D','#8282F5','#C9CF1D','#9682F5','#ABCF1D','#A982F5']
        },
        interaction: {
          enabled: true
        },
        zoom: {
          enabled: true
        },
        data: {
          columns: this.data.columns,
          types: this.data.types,
        },
        axis: {
          x: {
            label: {
              text: 'Kalenderwochen',
              /* position: 'outer-center' */
            },
            tick: {
              rotate: -30,
              multiline: false
            },
            height: 35,
            type: 'category',
            categories: this.categories,
          },
          y: {
            label: {
              text: 'Umsatz',
              position: 'outer-middle'
            },
            tick: {
              //format: germanFormatters.numberFormat("$,")
              format: function (d) {
                return Number(d).toLocaleString("de-DE", {minimumFractionDigits: 0}) + ' €';
              }
            }
          }
        },
        tooltip: {
          show: true,
          grouped: true,
          contents: function (d, defaultTitleFormat, defaultValueFormat, color) {

            var $$ = this, config = $$.config,
                titleFormat = config.tooltip_format_title || defaultTitleFormat,
                nameFormat = config.tooltip_format_name || function (name) { return name; },
                valueFormat = config.tooltip_format_value || defaultValueFormat,
                text, i, title, value, name, bgcolor;
            for (i = 0; i < d.length; i++) {
              if (! (d[i] && (d[i].value || d[i].value === 0))) { continue; }

              if (! text) {
                title = titleFormat ? titleFormat(d[i].x) : d[i].x;
                text = "<table class='" + $$.CLASS.tooltip + "'>" + (title || title === 0 ? "<tr><th colspan='2'>KW " + title + "</th></tr>" : "");
              }

              name = nameFormat(d[i].name);
              value = valueFormat(d[i].value, d[i].ratio, d[i].id, d[i].index);
              bgcolor = $$.levelColor ? $$.levelColor(d[i].value) : color(d[i].id);

              text += "<tr class='" + $$.CLASS.tooltipName + "-" + d[i].id + "'>";
              text += "<td class='name'><span style='background-color:" + bgcolor + "'></span>" + name + "</td>";
              text += "<td class='value'>" + value + "</td>";
              text += "</tr>";
            }
            return text + "</table>";
          },
          format: {
            /*
            title: function (d) {
              return 'KW ' + d;
              },

             */
            value: function (value) {
              //function (value, ratio, id) {
              //console.log(ratio);
              //console.log(id);
              var number = Number(value).toLocaleString("de-DE", {minimumFractionDigits: 2}) + ' €';
              return number;
            }
          }
        },
        /*
        tooltip: {
          format: {
            title(d) {
              return `第 ${d} 期`
            },
            value(value, ratio, id) {
              return `${value} 億円`
            }
          }
        },

         */
        grid: {
          x: {
            show: true
          },
          y: {
            show: true
          }
        },
        legend: {
          position: 'bottom',
        }
      }
    },

  },
  methods: {
    ...mapMutations([
    ]),
    ...mapActions([
    ]),
    ...mapGetters([
    ]),
    growingUp() {
      this.val = this.val + 50
      console.log(this.val, 'changed')
    },
    async getChartData() {
      //todo: local development
      var cookie = this.$store.getters.getToken;
      let categories = this.$store.getters.getStatisticFilterButtons;

      const response = await axios.post(
          this.API_URL,
          {
            type: 'get_chart_turnover_weeks',
            categories: categories,
            cookie: cookie,
          }
      );

      //console.log(response);

      this.data.columns = response.data.columns;
      this.data.types = response.data.types;
      this.categories = response.data.categories;

      //console.log(this.data.columns);
      //console.log(this.data.types);
      //console.log(this.categories);

      this.handler.$emit('init', this.options);
    }
  },
  watch: {
    options() {
      this.handler.$emit('dispatch', chart => {
        const options = {
          /*
          columns: [
            ['ddd', 0, 20, 10, 40, 15, this.val],
            ['xxx', 30, 200, 100, 400, 150, 250]
          ]

           */
        }
        chart.load(options)
      })
    },
    /*
    turnoverWeeks() {
      this.drawChart();
    }
     */
  }
}
</script>

<style scoped>

</style>